<template>
  <div class="space-y-24">
    <div class="flex items-center justify-between min-h-48">
      <TextIcon
        icon="svguse:#icon_trophy"
        text="My Highlights"
        icon-class="text-primary-pure"
        :div-class="
          titleSmall
            ? 'text-headline-1 !gap-12 !font-normal'
            : '!gap-12 !font-normal'
        "
      />

      <q-icon
        name="svguse:#icon_info_circle"
        class="text-neutral-70 size-24 cursor-pointer"
      >
        <q-tooltip
          anchor="top middle"
          self="bottom middle"
          class="bg-neutral-100 text-white"
        >
          Destaques personalizados para o seu desempenho na Copa.
        </q-tooltip>
      </q-icon>
    </div>

    <OTable
      ref="tableRef"
      :columns="columns"
      :rows="item?.highlights"
    >
      <template #body="_props">
        <q-tr :props="_props" class="!h-[3.625rem]">
          <q-td key="rank">
            {{ _props.row.rank }}
          </q-td>
          <!-- <q-td key="zone" auto-width class="min-w-120">
            {{ _props.row.zone }}
          </q-td> -->
          <q-td key="metric" auto-width class="min-w-120">
            {{ _props.row.metric }}
          </q-td>
          <q-td key="value" auto-width class="min-w-120">
            {{ fRowValue(_props.row.value) }}
          </q-td>
        </q-tr>
      </template>
      <template #bottom />
    </OTable>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import OTable from 'components/Table/OTable.vue'
import TextIcon from 'components/Text/TextIcon.vue'

defineProps({
  titleSmall: {
    type: Boolean,
    default: false,
  },
  item: {
    type: Object,
    required: true,
  },
})

const fRowValue = (v) => {
  if (String(v).includes('.')) {
    return Number(v).toFixed(1).replace('.', ',')
  }

  return v
}

const tableRef = ref(null)

const columns = [
  {
    name: 'rank',
    label: 'Ranking',
    align: 'left',
  },
  // {
  //   name: 'zone',
  //   label: 'Zone / Cluster',
  //   align: 'left',
  // },
  {
    name: 'metric',
    label: 'Metric',
    align: 'left',
  },
  {
    name: 'value',
    label: 'Actual Valor',
    align: 'center',
  },
]
</script>

<style scoped lang="sass">
:deep(.q-table thead tr th)
  @apply text-headline-3 bg-[#fafafa] text-neutral-70

:deep(.q-table tbody tr td)
  @apply text-headline-3 text-neutral-100
</style>
